import React from 'react';
import { useMaintenanceRedirect } from '../hooks/useMaintenanceRedirect';

const MaintenanceRedirectHandler: React.FC = () => {
  // Este hook detecta mudanças no modo manutenção e redireciona automaticamente
  useMaintenanceRedirect();
  
  return null; // Este componente não renderiza nada, apenas executa o hook
};

export default MaintenanceRedirectHandler;
